// The wire contract is shared by the site and packaged Android client.
export const CHAT_CHANGES = new Set(['ready', 'resync', 'chat_updated', 'new_chat', 'new_message', 'message_sent', 'phone_captured']);
export const endpoints = Object.freeze({
  staff: { path: '/api/chats/ws', pauseWhenHidden: false },
  portal: { path: '/api/client-portal/chat/ws', pauseWhenHidden: true },
});
export const chatProtocol = Object.freeze({
  authenticate: token => JSON.stringify({ type: 'auth', token }),
  decode(data) {
    try {
      const event = JSON.parse(data);
      return event && typeof event.type === 'string' ? event : null;
    } catch { return null; }
  },
  delivers: event => CHAT_CHANGES.has(event.type) || event.type === 'new_application',
});

export const retryDelay = attempt => Math.min(30000, 1000 * (2 ** Math.min(attempt, 5)));
